import React, {useState, useRef} from 'react';
import {observer} from 'mobx-react';
import PropTypes from 'prop-types';
import Autosuggest from 'react-autosuggest';
import {Card} from 'components/card';
import PopularPort from 'affiliates/Widget/FerrySearchMask/PopularPort';
import useOnClickOutside from 'helpers/hooks/useOnClickOutside';
import {
  themePort, selectAll, renderPortSuggestion
} from 'ferries/Home/components/FerrySearchMask/helperStore';

const showSuggestions = (value, popular) => {
  const valueLength = value.trim().length;
  return popular ? valueLength > 0 : valueLength >= 0;
};

const Port = ({
  type, className: {input}, placeholder, port, selected, popular, popularPorts, onChange, portString,
  fetchSuggestions, clearSuggestions, onSuggestionSelected, tripIndex, setPortByThreeLetterCode,
  translations
}) => {
  const [isPopularPortsOpen, setIsPopularPortsOpen] = useState(false);
  const refClickOutside = useRef(null);
  useOnClickOutside(refClickOutside, () => setIsPopularPortsOpen(false));

  const nofPopularPorts = popularPorts.length;

  const handleOpen = () => setIsPopularPortsOpen((isPopularPortsOpen) => !isPopularPortsOpen);
  const onClickPopularPort = (locationAbbr) => {
    setPortByThreeLetterCode(type, locationAbbr, tripIndex, true);
    handleOpen();
  };

  return (
    <div ref={refClickOutside}>
      <Autosuggest
        id={`${type}-${tripIndex}`}
        theme={{...themePort, input}}
        inputProps={{
          type: 'search',
          placeholder,
          value: port,
          onClick: (event) => {
            selectAll(event);
            handleOpen(true);
          },
          onChange: (ignore, {newValue}) => onChange(type, newValue, tripIndex)
        }}
        suggestions={selected.slice()}
        onSuggestionsFetchRequested={({value}) => fetchSuggestions(type, value, tripIndex)}
        onSuggestionsClearRequested={() => clearSuggestions(type, tripIndex)}
        getSuggestionValue={portString}
        renderSuggestion={renderPortSuggestion}
        shouldRenderSuggestions={(value) => showSuggestions(value, popular)}
        onSuggestionSelected={(event, {suggestion}) => onSuggestionSelected(type, suggestion, tripIndex, true)}
      />
      <div className="position-relative">
        {isPopularPortsOpen && port.length === 0 && popularPorts.length > 0 &&
          <Card
            shadow
            className="position-absolute p-2"
            style={{left: 0, top: 0, zIndex: 20, marginTop: '8px', width: '100%'}}
          >
            <div className="grid no-gutter">
              <div className="grid-item" style={{maxHeight: '145px', overflowY: 'auto'}}>
                <div className="mb-2 font-bold">{translations.mostPopular}</div>
                {popularPorts.map((popularPort, index) =>
                  <PopularPort
                    key={popularPort.ferryOwnLocationID}
                    {...popularPort}
                    popularPortClass="px-2"
                    isLast={nofPopularPorts - 1 === index}
                    onClickPopularPort={onClickPopularPort}
                  />
                )}
              </div>
            </div>
          </Card>}
      </div>
    </div>
  );
};

Port.propTypes = {
  type: PropTypes.string.isRequired,
  className: PropTypes.shape({
    input: PropTypes.string.isRequired
  }),
  placeholder: PropTypes.string.isRequired,
  selected: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  port: PropTypes.string.isRequired,
  popular: PropTypes.bool.isRequired,
  popularPorts: PropTypes.object.isRequired,
  portString: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onSuggestionSelected: PropTypes.func.isRequired,
  fetchSuggestions: PropTypes.func.isRequired,
  clearSuggestions: PropTypes.func.isRequired,
  tripIndex: PropTypes.number.isRequired,
  setPortByThreeLetterCode: PropTypes.func.isRequired,
  translations: PropTypes.shape({
    mostPopular: PropTypes.string.isRequired
  })
};

export default observer(Port);